import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { ListItemText } from '@mui/material';

const HtmlTooltip = styled(({ key, className, title, content, ...props }) => (
  <Tooltip
    TransitionComponent={Zoom}
    {...props}
    classes={{ popper: className }}
    title={
      <ListItemText
        primary={title}
        secondary={content}
        secondaryTypographyProps={{
          component: 'div',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      />
    }
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      theme.palette.mode === 'light' ? 'hsl(0, 0%, 100%)' : 'hsl(0, 0%, 0%)',
    color:
      theme.palette.mode === 'light' ? 'hsl(0, 0%, 0%)' : 'hsl(0, 0%, 100%)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid',
    maxWidth: 800,
    maxHeight: 800, // Set a maximum height
    overflowY: 'auto', // Enable vertical scrolling when content exceeds the height
    borderColor: theme.palette.divider,
  },
}));

export default HtmlTooltip;
